<!-- 签到页面 -->
<template>
  <div class='sign-container'>
    <top></top>
    <div class="title">
      <div class="left">
        <img src="../../assets/icon/icons8-calendar@2x.png">
        <span>{{year}}年{{month}}月 签到日历</span>
      </div>
      <div class="right" @click="showRule">
        <img src="../../assets/icon/icons8-rules@2x.png">
        <span>签到规则</span>
      </div>
    </div>
    <vue-checkin class="checkin" :checkin="checkInData"></vue-checkin>
    <div class="bottom">
      <div class="button" v-if="!isSign" @click="checkSign">立即签到</div>
      <div class="button disabled" v-else>已签到</div>
    </div>
    <van-popup v-model="show" class="rule-content">
      <h1>签到规则</h1>
      <p>{{rule.intro}}</p>
      <span @click="colseRule">确认</span>
    </van-popup>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Vue from 'vue'
import qs from 'qs'
import top from '@/components/top'
import VueCheckin from '@/components/vue-checkin'
import { Swipe, SwipeItem } from 'vant'
import { Popup } from 'vant'
import { Toast } from 'vant'

Vue.use(Popup)
Vue.use(Swipe).use(SwipeItem)

export default {
  name: 'Sign',
  components: { VueCheckin, top },
  data() {
    return {
      show: false,
      checkInData: [],
      isSign: false,
      year: null,
      month: null,
      date: null,
      rule: {}
    }
  },
  computed: {
    ...mapGetters(['userInfo'])
  },

  created() {
    this.getSign()
    this.getRule()
    var date = new Date()
    this.year = date.getFullYear()
    this.month = date.getMonth() + 1
    var year = date.getFullYear()
    var month = (date.getMonth() + 1) > 9 ? date.getMonth() + 1 : '0' + (date.getMonth() + 1)
    var day = date.getDate()
    this.date = year + '-' + month + '-' + day
  },

  methods: {
    getSign() {
      var that = this
      this.axios.get('/credit/log/?event=CHECK_IN&limit=100').then((res) => {
        console.log(res.data)
        for (const item of res.data.results) {
          var arr = item.created.split('T')
          item.created = arr[0]
          if (item.created === that.date) {
            that.isSign = true
          }
        }
        that.checkInData = res.data.results
      }).catch((err) => {
        console.log(err)
      })
    },

    getRule() {
      var that = this
      this.axios.get('/credit/rule/CHECK_IN/').then((res) => {
        that.rule = res.data
      }).catch((err) => {
        console.log(err)
      })
    },

    /**
     * 签到
     */
    checkSign() {
      var that = this
      var params = { event: 'CHECK_IN' }
      this.axios.post('/credit/event', qs.stringify(params)).then((res) => {
        console.log(res.data)
        if (res.data) {
          var arr = res.data.created.split('T')
          var created = arr[0]
          that.isSign = true
          that.checkInData.push({ 'created': created, 'credit': res.data.credit })
          that.$store.dispatch('updateCredit', that.userInfo.credit + res.data.credit)
          Toast('签到成功')
        }
      }).catch((err) => {
        console.log(err.response)
        if (err.response.status === 400) {
          Toast('今天已签到')
        }
        if (err.response.status === 500) {
          Toast('请求错误')
        }
      })
    },

    showRule() {
      this.show = true
    },

    colseRule() {
      this.show = false
    }
  }
}
</script>

<style lang="scss" scoped>
.sign-container {
  height: 100%;
  .title{
    height: 30px;
    margin-top: 60px;
    padding: 0 15px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .left{
      display: flex;
      align-items: center;
      img{
        width: 14px;
        height: 14px;
        margin-right: 10px;
      }
      span{
        color: #000000;
        font-size: 12px;
        font-weight: 400;
      }
    }
    .right{
      display: flex;
      align-items: center;
      img{
        width: 12px;
        height: 12px;
        margin-right: 10px;
      }
      span{
        color: #747474;
        font-size: 12px;
        font-weight: 400;
      }
    }
  }
  .checkin{
    margin: 5px 0 60px;
    background-color: #ffffff;
  }
  .bottom{
    width: 100%;
    height: 58px;
    box-shadow: 0 -1px 8px 1px rgba(235, 235, 235, 0.5);
    background-color: #ffffff;
    position: fixed;
    bottom: 0;
    .button{
      width: 150px;
      height: 40px;
      border-radius: 100px;
      background-color: #003485;
      margin: 9px auto;
      text-align: center;
      line-height: 40px;
      color: #ffffff;
      font-size: 14px;
      font-weight: 600;
    }
    .disabled{
      background-color: gray;
    }
  }
  .rule-content{
    width: 250px;
    padding: 25px;
    box-shadow: 0 0 8px 4px rgba(0, 0, 0, 0.12);
    border-radius: 5px;
    background-color: #ffffff;
    h1{
      color: #4a4a4a;
      font-size: 16px;
      font-weight: 600;
      margin: 0;
      text-align: center;
    }
    p{
      margin: 20px 0;
      color: #4a4a4a;
      font-size: 16px;
      font-weight: 400;
      line-height: 25px;
    }
    span{
      color: #4a90e2;
      font-size: 16px;
      font-weight: 400;
      float: right;
    }
  }
}
</style>
<style lang="scss">
.van-popup{
  width: 90%;
  border-radius: 5px;
}
.calendar .sign_tab td.cur_day{
  background-color: #003485 !important;
}
.calendar .sign_tab td{
  padding: 20px 0 !important;
}
.calendar{
  margin: 0 !important;
}
.calendar button{
  display: none;
}
.calendar h4{
  display: none;
}
.calendar .ui-state-default, .calendar .ui-state-down{
  bottom: 5px !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/activity/sign.vue